
export default {
    name: 'rapport-creance',
    components: {},
    props: {
        rapport_creances: Array,
        by_type_creance: String,
        by_prestation: String,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'montant_paye', label: 'Montant payé' }, 
                { key: 'reste_a_payer', label: 'Rst*' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            creance_len: 0,
            liste_creances: []
        }
    },

    watch: {
        modal_toggler() {
            this.refreshRecette()
            this.filter = this.by_prestation
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshRecette() {
            this.liste_creances = []
            if (this.rapport_creances) {
                this.creance_len = this.rapport_creances.length

                if (this.by_type_creance == 'tout' || this.by_type_creance == '') {
                    this.liste_creances = this.rapport_creances
                } else {
                    this.rapport_creances.forEach(creance => {
                        if (creance.etat_paiement == this.by_type_creance) {
                            this.liste_creances.push(creance)
                        }
                    }); 
                }
                
            }
        }
    }
}